<div *ngIf="deviceParamGatewayV3Network">

<button *ngIf="deviceParamGatewayV3NetworkForm && !showDeviceParamGatewayV3NetworkForm && editable" class="btn btn-info" (click)="setEditable()">Add
    #{{deviceParamGatewayV3Network?.length}}
</button>
<div *ngIf="deviceParamGatewayV3NetworkForm && showDeviceParamGatewayV3NetworkForm && editable" class="edit-container-params">
    <h4>{{currentTriggerDataIndexForEdition !== null ? 'Edit ' : 'Add ' }}
        #{{currentTriggerDataIndexForEdition
        !== null ? currentTriggerDataIndexForEdition : deviceParamGatewayV3Network?.length }}
    </h4>
    <form [formGroup]="deviceParamGatewayV3NetworkForm">

        <mat-form-field>
            <input matInput placeholder="{{'TYPE' | translate}} :"
                   formControlName="type" required type="text">
        </mat-form-field>

        <mat-form-field>
            <input matInput placeholder="{{'GET_IP' | translate}} :"
                   formControlName="get_ip" type="text">
        </mat-form-field>

        <mat-form-field>
            <input matInput placeholder="{{'IFACE' | translate}} :"
                   formControlName="iface" type="text">
        </mat-form-field>
        <mat-form-field>
            <input matInput placeholder="{{'IP' | translate}} :"
                   formControlName="ip" type="text">
        </mat-form-field>

        <mat-form-field>
            <input matInput placeholder="{{'NETMASK' | translate}} :"
                   formControlName="netmask" type="text">
        </mat-form-field>

        <mat-form-field>
            <input matInput placeholder="{{'GW' | translate}} :"
                   formControlName="gw" type="text">
        </mat-form-field>

        <mat-form-field>
            <input matInput placeholder="{{'DNS' | translate}} :"
                   formControlName="dns" type="text">
        </mat-form-field>

        <mat-form-field>
            <input matInput placeholder="{{'PINCODE' | translate}} :"
                   formControlName="pincode" type="text">
        </mat-form-field>

        <mat-form-field>
            <input matInput placeholder="{{'PSK' | translate}} :"
                   formControlName="psk" type="text">
        </mat-form-field>

        <mat-form-field>
            <input matInput placeholder="{{'SSID' | translate}} :"
                   formControlName="ssid" type="text">
        </mat-form-field>

        <mat-form-field>
            <input matInput placeholder="{{'SECURITY' | translate}} :"
                   formControlName="security" type="text">
        </mat-form-field>


        <button class="btn btn-danger btn-float-right" (click)="cancelTriggerData()">
            {{'CANCEL' | translate}}
        </button>
        <button class="btn btn-success btn-float-right" *ngIf="currentTriggerDataIndexForEdition !== null"
                (click)="editTriggerData()">{{'EDIT' | translate}}
            #{{currentTriggerDataIndexForEdition}}
        </button>
        <button class="btn btn-info btn-float-right" *ngIf="currentTriggerDataIndexForEdition === null"
                (click)="addTriggerData()">{{'ADD' | translate}}

        </button>
    </form>


</div>
<div *ngFor="let netWork of deviceParamGatewayV3Network;let i = index">
    <div *ngIf="currentTriggerDataIndexForEdition === null" class="read-container-params">
        <h4> Network #{{i}}</h4>
        <form>

            <mat-form-field>
                <input matInput placeholder="{{'TYPE' | translate}}  :"
                       [value]="deviceParamGatewayV3Network[i].type"
                       [readonly]="true"
                       type="text">
            </mat-form-field>

            <mat-form-field>
                <input matInput placeholder="{{'GET_IP' | translate}}  :"
                       [value]="deviceParamGatewayV3Network[i].get_ip !== undefined ? deviceParamGatewayV3Network[i].get_ip : ''"
                       [readonly]="true"
                       type="text">
            </mat-form-field>

            <mat-form-field>
                <input matInput placeholder="{{'IFACE' | translate}} :"
                       [value]="deviceParamGatewayV3Network[i].iface !== undefined ?  deviceParamGatewayV3Network[i].iface : ''"
                       [readonly]="true"
                       type="text">
            </mat-form-field>

            <mat-form-field>
                <input matInput placeholder="{{'IP' | translate}} :"
                       [value]="deviceParamGatewayV3Network[i].ip !== undefined ? deviceParamGatewayV3Network[i].ip  : ''"
                       [readonly]="true"
                       type="text">
            </mat-form-field>

            <mat-form-field>
                <input matInput placeholder="{{'NETMASK' | translate}} :"
                       [value]="deviceParamGatewayV3Network[i].netmask !== undefined ? deviceParamGatewayV3Network[i].netmask : '' "
                       [readonly]="true"
                       type="text">
            </mat-form-field>

            <mat-form-field>
                <input matInput placeholder="{{'GW' | translate}} :"
                       [value]="deviceParamGatewayV3Network[i].gw !== undefined ? deviceParamGatewayV3Network[i].gw : ''"
                       [readonly]="true"
                       type="text">
            </mat-form-field>

            <mat-form-field>
                <input matInput placeholder="{{'DNS' | translate}} :"
                       [value]="deviceParamGatewayV3Network[i].dns !== undefined ? deviceParamGatewayV3Network[i].dns  : '' "
                       [readonly]="true"
                       type="text">
            </mat-form-field>

            <mat-form-field>
                <input matInput placeholder="{{'PINCODE' | translate}} :"
                       [value]="deviceParamGatewayV3Network[i].pincode !== undefined ?  deviceParamGatewayV3Network[i].pincode  : '' "
                       [readonly]="true"
                       type="text">
            </mat-form-field>

            <mat-form-field>
                <input matInput placeholder="{{'PSK' | translate}} :"
                       [value]="deviceParamGatewayV3Network[i].psk !== undefined ? deviceParamGatewayV3Network[i].psk :'' "
                       [readonly]="true"
                       type="text">
            </mat-form-field>

            <mat-form-field>
                <input matInput placeholder="{{'SSID' | translate}} :"
                       [value]="deviceParamGatewayV3Network[i].ssid !== undefined ? deviceParamGatewayV3Network[i].ssid  : '' "
                       [readonly]="true"
                       type="text">
            </mat-form-field>

            <mat-form-field>
                <input matInput placeholder="{{'SECURITY' | translate}} :"
                       [value]="deviceParamGatewayV3Network[i].security !== undefined ? deviceParamGatewayV3Network[i].security : '' "
                       [readonly]="true"
                       type="text">
            </mat-form-field>

            <button class="btn btn-danger btn-float-right" *ngIf="currentTriggerDataIndexForEdition !== i && editable"
                    (click)="removeTriggerData(i)">
                {{'DELETE' | translate}}
            </button>
            <button class="btn btn-success btn-float-right" *ngIf="currentTriggerDataIndexForEdition !== i && editable"
                    (click)="setFormWithTriggerData(i)">{{'EDIT' | translate}}
                #{{i}}
            </button>

        </form>

    </div>
</div>

</div>
